import { render, staticRenderFns } from "./BtnPrintTplStandard.vue?vue&type=template&id=dce1dd3e"
import script from "./BtnPrintTplStandard.vue?vue&type=script&lang=js"
export * from "./BtnPrintTplStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports